export const app_enabled_disabled_tr = {
  true: 'Devrede',
  false: 'Devre Dışı',
};
